import { combine, createEvent, sample } from 'effector'
import { register } from '~/core/repository'
import { model as sessionModel } from '~/entities/session'
import { showsFavoritesEntityModel } from '~/entities/shows/favorites'
import { nay } from '~/shared/helpers'
import { libraryGridFavoritesTvShowsWidget } from '~/widgets/library/grid/favorites/tvShows'
import { $libraryFavoritesTvShowsTranslations } from './translations'

export const initLibraryFavoritesTvShowsPage = createEvent()
export const leftLibraryFavoritesTvShowsPage = createEvent()

sample({
  clock: initLibraryFavoritesTvShowsPage,
  target: libraryGridFavoritesTvShowsWidget.loadGridFavoritesTvShows,
})

export const $isLibraryFavoritesTvShowsEmptyPage = combine(
  showsFavoritesEntityModel.$onlyFavoritesTvShowsGrid,
  (onlyFavoritesTvShowsGrid) =>
    onlyFavoritesTvShowsGrid && !onlyFavoritesTvShowsGrid.content.length
)

sample({
  source: leftLibraryFavoritesTvShowsPage,
  target: showsFavoritesEntityModel.resetOnlyFavoritesTvShowsGrid,
})

sample({
  source: sessionModel.$authenticated,
  filter: nay,
  target: showsFavoritesEntityModel.resetOnlyFavoritesTvShowsGrid,
})

register(
  $libraryFavoritesTvShowsTranslations,
  '$libraryFavoritesTvShowsTranslations'
)
register(
  showsFavoritesEntityModel.$onlyFavoritesTvShowsGridFormatted,
  '$library/favorites/tvShows/onlyFavoritesTvShowsGridFormatted'
)
register(
  $isLibraryFavoritesTvShowsEmptyPage,
  '$isLibraryFavoritesTvShowsEmptyPage'
)
register(
  libraryGridFavoritesTvShowsWidget.loadMoreGridFavoritesTvShows,
  'loadMoreGridFavoritesTvShows'
)
